import PropTypes from "prop-types"
import { useLocale } from "react-polyglot-hooks"
import { useRouter } from "next/router"
import { isMainMenuCollectionPath } from "helpers/structuredData"
import Collection from "../Collection"

export default function MainMenuCollection({ cars, name, path }) {
  const locale = useLocale()
  const { asPath } = useRouter()
  const pathname = (path || asPath).split("?")[0].replace(/\/$/, "")

  if (!isMainMenuCollectionPath(pathname)) return null

  return (
    <Collection
      cars={cars}
      locale={locale}
      name={name}
      url={`https://swipcar.com${pathname}`}
    />
  )
}

MainMenuCollection.propTypes = {
  cars: PropTypes.array.isRequired,
  name: PropTypes.string.isRequired,
  path: PropTypes.string
}

MainMenuCollection.defaultProps = {
  path: null
}
